<template>
  <div class="pon-widget" ref="ponWidgetRef">
    <CallPonButton @click="togglePonPopup" :disabled="!hasPaidAccount || isLoadingUserData" />
    <transition name="animation-fade-up">
      <PonModule v-if="isPonPopupOpen" class="pon-widget__dropdown"/>
    </transition>
  </div>
</template>

<script setup>
  import { ref, onMounted, onUnmounted } from 'vue';
  import { usePonPopup } from '@/Groups/Pon/private/imports/toggleDropdown';
  import { useScreenSize } from '@/Groups/Pon/private/imports/screenSize';
  //--------------------------------
  import CallPonButton from "@/Groups/Pon/private/core/CallPonButton/CallPonButton.vue";
  import PonModule from "@/Groups/Pon/private/core/PonModule/PonModule.vue";
  import {useUserAuth} from "@/Groups/Pon/private/imports/userStoreData";
  //--------------------------------
  const { screenWidth } = useScreenSize();
  const { open } = usePonPopup();
  //--------------------------------
  const isPonPopupOpen = ref(false);
  const ponWidgetRef = ref(null);
  //--------------------------------
  const {hasPaidAccount, isLoadingUserData} = useUserAuth();
  const togglePonPopup = () => {
    if(screenWidth.value >= 576){
      if (!hasPaidAccount.value || isLoadingUserData.value) return;
      isPonPopupOpen.value = !isPonPopupOpen.value;
    }else{
      open();
    }
  };
  //--------------------------------
  function handleClickOutside(event) {
    if (!ponWidgetRef.value) return;
    if (!ponWidgetRef.value.contains(event.target)) {
      isPonPopupOpen.value = false;
    }
  }
  //--------------------------------
  onMounted(() => {
    document.addEventListener('mousedown', handleClickOutside);
  });

  onUnmounted(() => {
    document.removeEventListener('mousedown', handleClickOutside);
  });
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>
